<template>
    <div class="v-card__title">
        <v-spacer></v-spacer>
        <botao-avancar-salvar-itens :deveHabilitarBotoes="deveHabilitarBotoes" @savlarItensEAvancar="$emit('savlarItensEAvancar')"/>
    </div>
</template>

<script>
import BotaoAvancarSalvarItens from "./BotaoAvancarSalvarItens.vue"

export default {
    name: 'ListarItemCredenciamentoHeaderBarraBotoes',
    components: { BotaoAvancarSalvarItens },
    props: {
        deveHabilitarBotoes: {
            type:Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="stylus">

</style>